/**************************************************
 * Nombre:       Seccion_Formacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Servicios from "./Componentes/Home_Servicios";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import Home_Documentos from "./Componentes/Home_Documentos";
import Home_Preguntas from "./Componentes/Home_Preguntas";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import {SECCIONES} from "../../Constantes";

const Seccion_Formacion = () => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Portada/>
            </Grid>

            <Grid id={SECCIONES[1]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: -18}}>
                <Home_Servicios/>
            </Grid>

            <Grid id={SECCIONES[2]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -12}}>
                <Home_Documentos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Preguntas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14, mb: 14}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Formacion    